import Vue from 'vue';
import Router from 'vue-router';

import Home from '../views/Home.vue';
import About from '../views/About.vue';
import Contact from '../views/Contact.vue';

import Blog from '../views/blog/Blog.vue';
import BlogCategories from '../views/blog/BlogCategories.vue';
import BlogPost from '../views/blog/BlogPost.vue';

/*albums display particular album, with photos and locations for particular album*/
import Album from '../views/albums/Album.vue';
import AlbumLocation from '../views/albums/AlbumLocation.vue';
import AlbumPhoto from '../views/albums/AlbumPhoto.vue';
/*photos display all photos, with filter for albums and locations*/
import Gallery from '../views/gallery/Gallery.vue';
import GalleryAlbum from '../views/gallery/GalleryAlbum.vue';
import GalleryPhoto from '../views/gallery/GalleryPhoto.vue';
/*locations display all locations, add filters for albums*/
import Location from '../views/locations/Location.vue';

Vue.use(Router);

let routes = [
    {
        name: 'Domov',
        path: '/',
        // use vue ext if you have setup outside the laravel
        component: Home,
        props: true,
        meta: {
            title: route => {
                // console.log('home route: ' , route.name);
                return route.name;
            },
            transitionName: 'zoomIn'
        },
    },
    {
        name: 'O nas',
        path: '/o-nas',
        component: About,
        meta: {
            title: route => {
                return route.name;
            },
            transitionName: 'fadeOutUp'
        }
    },
    {
        name: 'Kontakt',
        path: '/kontakt',
        component: Contact,
        meta: {
            title: route => {
                return route.name;
            }
        }
    },
    {
        path: '/blog',
        name: 'Blog',
        component: Blog,
        props: true,
        meta: {
            title: route => {
                return route.name;
            },
            transitionName: 'fadeInRight'
        }
    },
    {
        path: '/blog/:category',
        name: 'BlogCategories',
        component: BlogCategories,
        props: true,
        meta: {
            title: route => {
                return route.name;
            },
            transitionName: 'zoomIn'
        }
    },

    {
        path: '/blog/:categorySlug/:postSlug',
        name: 'BlogPost',
        component: BlogPost,
        props: true,
        meta: {
            title: route => {
                return route.name;
            },
            transitionName: 'slideInRigth'
        }
    },

    // Gallery
    {
        path: '/galerija',
        name: 'Galerija',
        component: Gallery,
        props: true,
        meta: {
            title: route => {
                // console.log('plain gallery');
                return route.name;
            }
        }
    },
    // in .htaccess redirect galerija?page=... with new paths galerija/p/..
    {
        path: '/galerija/p/:page',
        name: 'galleryPage',
        component: Gallery,
        props: true,
        meta: {
            title: route => {
                // console.log('page gallery');
                return route.name;
            }
        }
    },
    // external link, do we need children links?
    {
        path: '/galerija/album/:album/:page?',
        name: 'galleryAlbum',
        component: GalleryAlbum,
        props: true,
        meta: {
            title: route => {
                // console.log('here we are-album path: ', route.path);
                return route.name;
            }
        }
    },
    // this MUST exist for the SEO - indexed images from old page
    {
        path: '/galerija/:photo',
        name: 'galleryPhotos',
        component: GalleryPhoto,
        props: true,
        meta: {
            title: route => {
                // console.log('here we are-photo path: ', route.path);
                return route.name;
            }
        }
    },
    /*{
        path: '/galerija',
        name: 'Gallery',
        component: Gallery,
        children: [
            // {
            //   path: 'album/:album/:p?',
            //   name: 'galleryAlbums',
            //   component: GalleryAlbum,
            //   props: { albumDetails: true, photoDetails: false }
            // },
            // {
            //   path: ':photo',
            //   name: 'galleryPhotos',
            //   component: GalleryPhoto,
            //   props: { photoDetails: true, albumDetails: false }
            // },
        ]
    },*/

    {
        path: '/:id',
        name: 'Album',
        component: Album,
        props: true,
        meta: {
            title: route => {
                // console.log('album route: ' , route.params.id);
                return route.params.id;
            }
        },

        // Append additional oontent to parent, don't forget to add
        // router-view in parent component!!
        /*children: [
            {
                path: ':location',
                name: 'AlbumLocation',
                component: AlbumLocation,
                props: true,
                meta: {
                    title: route => {
                        console.log('children route Alocation: ', route.params.id)
                        console.log('route: ' , route.params.location);
                        return route.location + ' ' + (route.params.location)
                    }
                }
            },
            {
                path: ':photo',
                name: 'AlbumPhoto',
                component: AlbumPhoto,
                props: true,
                meta: {
                    title: route => {
                        console.log('children route Aphoto: ', route.params.photo)
                        return route.name + ' ' + (route.params.photo) }
                }
            },
        ]*/
    },
    {
        path: '/l/:location',
        name: 'Location',
        component: Location,
        props: true,
        meta: {
            title: route => {
                // console.log(' route just location: ', route.params.location)
                // console.log('route: ' , route.params.location);
                return route.params.location;
            }
        }
    },
    {
        path: '/:album/:location',
        name: 'AlbumLocation',
        component: AlbumLocation,
        props: true,
        meta: {
            title: route => {
                // console.log(' route Alocation: ', route.params.location)
                // console.log('route: ' , route.params.location);
                return route.params.location;
            }
        }
    },
    {
        path: '/:album/:location/:photo',
        name: 'AlbumPhoto',
        component: AlbumPhoto,
        props: true,
        meta: {
            title: route => {
                // console.log(' route Aphoto: ', route.params.photo, route.name)
                return route.params.photo;
            }
        }
    },

];

let router = new Router({
    routes,
    mode: 'history',
    history: true,
    linkActiveClass: 'is-active',
    scrollBehavior: () => ({ y: 0 }),
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js